import { useUser } from '../Contexts/UserContext';
import ClientBills from '../Screens/Client/EnergyBills';
import TenantBills from '../Screens/Tenant/EnergyBills';

export default function EnergyBills() {
    const { type } = useUser();

    return (
        <>
            {type == 'client' && <ClientBills />}
            {type == 'tenant' && <TenantBills />}
        </>
    );
}